import styled from "styled-components"

const FlexWrapper = styled.span`
  display: flex;
  flex-direction: ${({direction}) => direction || "row"};
  align-items: ${({align}) => align || "flex-start"};
  justify-content: ${({justify}) => justify || "flex-start"};
`

export default FlexWrapper
